<template>
  <img class="start__cover-img" src="/static/img/start/cover.png">

  <div class="start">
    <div class="start__text">
      <span class="accent">Миссия Зоозаврика —</span> помочь Вам стать ответственным владельцем питомца
    </div>
    <img class="start__img" src="/static/img/start/zoozavr.png">
    <button
      class="btn start__btn"
      @click="$emit('choose-pet')"
      onclick="sendEventYM(
         102182679,
         'step1_click_btn'
       );"
    >ПРОВЕРЬТЕ СВОИ ЗНАНИЯ</button>
  </div>
</template>

<script>
export default {
  name: 'StartWindow'
}
</script>

<style lang="scss" scoped>
.status-bar {
  background-color: transparent;
}

.start {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  min-height: 100dvh;

  @media (min-width: $lg) {
    justify-content: center;
  }

  &__cover-img {
    position: absolute;
    top: 0;
    right: 0;
    width: 77vw;
    max-width: 300px;
    z-index: -1;

    @media (min-width: $lg) {
      width: 100vw;
      height: 100vh;
      max-width: unset;
      object-fit: cover;
    }
  }

  &__text {
    @include type-36;

    margin: 57.4% auto 0;
    width: 92%;
    font-weight: 500;

    @media (min-width: $lg) {
      margin: 0;
      max-width: 585px;
    }
  }

  &__img {
    margin: 9px auto;
    object-fit: contain;
    max-width: 92%;

    @media (min-width: $lg) {
      order: -1;
      margin: 0 auto 41px;
      max-width: 387px;
    }
  }

  &__btn {
    margin-top: auto;
    margin-bottom: 42px;
    @media (min-width: $lg) {
      margin-top: 30px;
    }
  }
}
</style>
